
export function updatePushNotifications(state, value) {
  state.pushNotifications = value;
}




